import { Data } from "../Data";

export class ImpersonateUser extends Data {
  constructor(options: any) {
    super({
      api: "/User/Impersonate" + (options.employeeId ? "?employeeId=" + options.employeeId : ""),
      callback: (data: any) => {
        options.resolve(this, false);
      },
      ...options
    });
  }

  static post(context: any, employeeId: any) {
    return new Promise(
      (resolve, reject) =>
        new ImpersonateUser({ resolve, reject, context, employeeId, method: "post" })
    );
  }
}
